import { FloorMapSpaces } from '@api'

import { Button } from '@runeffective/evo-design-system'
import { Flex } from '@ui'
import ChartSection from 'components/ChartSection'
import { getColor } from 'components/Reports/config'
import { groupBy, keys } from 'lodash'
import React, { useState } from 'react'
import typescriptNaturalSort from 'typescript-natural-sort'
import CapacitySectionPopup from './capacitySectionPopup'

const formatData = (spaces: any, selectedItems: string[]) => {
  const { byId } = spaces
  const items = selectedItems.reduce(
    (result: any, id: string) => (byId[id] ? [...result, byId[id]] : result),
    []
  )

  const grouped = groupBy(items, ({ capacity }) => capacity)

  return keys(grouped)
    .sort((k1, k2) => typescriptNaturalSort(k1, k2))
    .map((key, i) => ({
      key,
      color: `#${getColor(i)}`,
      units: '',
      xLabel: 'Capacity',
      x: Number(key),
      y: grouped[key].length,
    }))
}

const CapacitySection = ({
  spaces,
  selectedItems,
}: {
  spaces: FloorMapSpaces
  selectedItems: string[]
}) => {
  const chartData = formatData(spaces, selectedItems)
  const [isCapacityOpen, setIsCapacityOpen] = useState(false)

  return (
    <div style={{ margin: '10px' }}>
      <ChartSection chartType="bar" colName="capacity" description="" data={chartData} />
      <Flex style={{ width: '100%', margin: '5px' }} direction="row" justify="space-between">
        <Button
          layout="secondary"
          onClick={() => {
            setIsCapacityOpen(true)
          }}
          size="small"
        >
          Update capacity
        </Button>
      </Flex>
      <CapacitySectionPopup
        selectedSpaces={selectedItems}
        isCapacityOpen={isCapacityOpen}
        setIsCapacityOpen={setIsCapacityOpen}
      />
    </div>
  )
}

export default CapacitySection
